/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ExpandDetails from 'shared/ui/components/ExpandDetails.vue';

const __vue_script__ = {
    name: 'MailingLogDetailsModal',

    components: { ExpandDetails },

    props: {
        event: {
            type: Object,
            required: true
        },

        docId: {
            type: String,
            required: true
        },

        item: {
            type: Object,
            required: true
        },

        title: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            doc: {},
            ready: false
        };
    },

    computed: {
        status() {
            return this.doc.status || this.$t('base.unknown');
        },

        statusBadgeClass() {
            if (this.status === 'sent') {
                return 'badge-info';
            } else if (this.status === 'delivered') {
                return 'badge-success';
            } else if (this.status.includes('bounced')) {
                return 'badge-danger';
            }

            return 'badge-warn';
        },

        preview() {
            return this.doc.html || this.doc.message?.html;
        },

        compiledEmail() {
            if (!this.doc.message || !this.preview) return null;
            let { global_merge_vars: globs, merge_vars, to } = this.doc.message;
            let userVars = merge_vars.find(({ rcpt }) => rcpt === to)?.vars || {};

            if (Array.isArray(globs)) {
                globs = globs.reduce((acc, { name, content }) => {
                    acc[name] = content;
                    return acc;
                }, {});
            }

            if (Array.isArray(userVars)) {
                userVars = userVars.reduce((acc, { name, content }) => {
                    acc[name] = content;
                    return acc;
                }, {});
            }

            const replacements = { ...globs, ...userVars };
            return this.$utils.dom.compile(this.preview, replacements);
        },

        filteredDoc() {
            return {
                ...this.doc,
                html: undefined,
                message: {
                    ...this.doc.message,
                    html: undefined
                }
            };
        },

        canUseEditor() {
            const isEditorInstalled = this.$services.blueprint.isModuleInstalled('document-editor');
            const hasDocId = this.doc?._id;
            return isEditorInstalled && hasDocId && this.$services.user.isSuperAdmin();
        },

        editorLink() {
            if (!this.canUseEditor) return null;

            const docEditor = this.$services.blueprint.getModuleByName('document-editor');
            const path = this.$utils.modules.getRouteHref(docEditor, 'document-editor', { eventId: this.event._id });

            return `${path}?document=${this.doc._id}`;
        },

        hasError() {
            return this.doc.hasOwnProperty('error_msg') || this.doc.hasOwnProperty('error_details');
        }
    },

    async created() {
        try {
            this.doc = await this.$services.appScripts.callAppScript(this.event._id, 'mail/retrieve-item', { id: this.docId });
        } catch (error) {
            console.error('[MailingLogDetailsModal] Error fetching log document', error.message);
        } finally {
            this.ready = true;
        }
    },

    methods: {
        openPreview() {
            if (!this.preview) return;
            this.$modal.show('preview');

        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mailing-log-details-modal modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),(_vm.ready)?_c('div',{staticClass:"modal-body"},[_c('section',{staticClass:"mail-logs-view"},[_c('h4',[_vm._v(_vm._s(_vm.$t('emailing.logs.overview')))]),_c('div',{staticClass:"table-wrapper"},[_c('table',[_c('thead',[_c('tr',[(_vm.doc.name)?_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.name')))]):_vm._e(),(_vm.doc.message)?_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.to')))]):_vm._e(),(_vm.doc.message)?_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.subject')))]):_vm._e(),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.queued')))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.status')))])])]),_c('tbody',[_c('tr',[(_vm.doc.name)?_c('td',[_vm._v(_vm._s(_vm.doc.name))]):_vm._e(),(_vm.doc.message)?_c('td',[_vm._v(_vm._s(_vm.doc.message.to))]):_vm._e(),(_vm.doc.message)?_c('td',[_vm._v(_vm._s(_vm.doc.message.subject))]):_vm._e(),_c('td',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(_vm.doc.timestamp, 'LLL', _vm.event.timezone)))]),_c('td',[_c('div',{staticClass:"badge",class:_vm.statusBadgeClass},[_vm._v(_vm._s(_vm.status))]),(_vm.status === 'soft-bounced' && _vm.doc.bounce_description)?_c('span',[_vm._v(_vm._s(_vm.$utils.strings.humanize(_vm.doc.bounce_description, true)))]):_vm._e()])])])])]),(_vm.hasError)?_c('div',{staticClass:"error-details"},[_c('div',{staticClass:"alert alert-error"},[(_vm.doc.error_msg)?_c('p',[_vm._v(_vm._s(_vm.doc.error_msg))]):_vm._e(),_c('expand-details',{attrs:{"label":_vm.$t('general.error_details'),"open":!_vm.doc.error_msg}},[(_vm.doc.error_details)?_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"compact"},_vm._l((_vm.doc.error_details),function(value,key){return _c('tr',[(key !== '_id' && value)?[_c('th',[_vm._v(_vm._s(((_vm.$utils.strings.humanize(key, true)) + ":")))]),_c('td',[(typeof value === 'string')?_c('code',[_vm._v(_vm._s(value))]):_c('pre',[_vm._v(_vm._s(value))])])]:_vm._e()],2)}),0)]):_vm._e()])],1)]):_vm._e()]),(_vm.doc.status === 'sent')?_c('section',{staticClass:"mail-logs-details"},[_c('h4',[_vm._v(_vm._s(_vm.$t('emailing.logs.analytics')))]),_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"compact"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.opened')))]),_c('td',[_vm._v(_vm._s(_vm.$tc('emailing.logs.messages.occurrences', [_vm.doc.opens], [_vm.doc.opens])))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.clicked')))]),_c('td',[_vm._v(_vm._s(_vm.$tc('emailing.logs.messages.occurrences', [_vm.doc.clicks], [_vm.doc.clicks])))])]),_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.last_opened')))]),_c('td',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(_vm.doc.last_open, 'LLL', _vm.event.timezone)))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.logs.headers.last_clicked')))]),_c('td',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(_vm.doc.last_click, 'LLL', _vm.event.timezone)))])])])])]):_vm._e(),(_vm.doc.report)?_c('section',{staticClass:"mail-logs-details"},[_c('h4',[_vm._v(_vm._s(_vm.$t('emailing.logs.reports')))]),_vm._l((_vm.doc.report),function(report){return _c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"compact"},_vm._l((report),function(value,name){return _c('tr',[(name !== '_id' && value)?[_c('th',[_vm._v(_vm._s(((_vm.$utils.strings.humanize(name, true)) + ":")))]),_c('td',[_vm._v(_vm._s(value))])]:_vm._e()],2)}),0)])})],2):_vm._e(),(_vm.doc.smtp_events)?_c('section',{staticClass:"mail-logs-details"},[_c('h4',[_vm._v(_vm._s(_vm.$t('emailing.logs.smtp_events')))]),_vm._l((_vm.doc.smtp_events),function(event){return _c('div',{staticClass:"smpt-event"},[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"compact"},[_c('tr',[_c('th',[_vm._v("SMTP event:")]),_c('td',[_vm._v(_vm._s(this.$utils.strings.capitalize(event.type)))])]),_c('tr',[_c('th',[_vm._v("Timestamp:")]),_c('td',[_vm._v(_vm._s(this.$utils.time.tsToFormat(event.ts, 'LLL', event.timezone)))])])])]),(event.type !== 'sent')?_c('pre',{staticClass:"smpt-diag"},[_vm._v(_vm._s(event.diag))]):_vm._e()])})],2):_vm._e()]):_vm._e(),_c('div',{staticClass:"modal-footer"},[(_vm.editorLink)?_c('a',{staticClass:"btn btn-warn",attrs:{"target":"_blank","href":_vm.editorLink,"rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('emailing.logs.open_in_editor')))]):_vm._e(),(_vm.preview)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.openPreview}},[_vm._v(_vm._s(_vm.$t('emailing.logs.preview')))]):_vm._e(),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.close')))])]),(_vm.preview)?_c('modal',{attrs:{"name":"preview","classes":"large","height":"auto"}},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$modal.hide('preview')}}}),_c('h3',[_vm._v(_vm._s(_vm.$t('emailing.logs.log_html')))])]),_c('div',{staticClass:"modal-body"},[_c('iframe',{attrs:{"srcdoc":_vm.compiledEmail}})])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MailingLogDetailsModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__